export class HssItem {
  text: string;
  didChange: boolean;
  readonly property: string | null;

  constructor(
    property: string | null,
    text: string = "",
    didChange: boolean = false
  ) {
    this.text = text;
    this.didChange = didChange;
    this.property = property;
  }
}
